//  ----------      START   IMPORT  BLOCK       ----------
//  Services
import APIService from '../Core/APIService';
//  Config
import API_ROUTES from '../../ConfigFiles/Routes/api_routes';
//  ----------      END   IMPORT  BLOCK       ----------

export default class GeneralInfoService extends APIService {
  async readFullName(query) {
    // Route is now relative to the base URL
    const route = API_ROUTES.read_full_name(query);
    return this.get(route);
  }
}